const legal = {
  infoPageLayout: {
    manageCookies: "Gérer mes cookies",
  },
  terms: {
    title: "Conditions d'utilisation",
    subtitle: "Règles générales applicables à l’accès et à l’utilisation de Qubiq.",
    sections: [
      {
        title: "1. Objet",
        body: "{{brandName}} est une plateforme de streaming vidéo interactive permettant de regarder des contenus, d’interagir avec des jeux intégrés et d’utiliser des fonctionnalités communautaires.",
      },
      {
        title: "2. Accès au service",
        body: "L’accès à certaines fonctions de Qubiq nécessite la création d’un compte. L’utilisateur s’engage à fournir des informations exactes, à conserver la confidentialité de ses accès et à ne pas détourner le service de son usage normal.",
      },
      {
        title: "3. Contenus et comportements interdits",
        body: "Il est interdit de publier, diffuser ou relayer des contenus illicites, frauduleux, haineux, violents, trompeurs, pornographiques non autorisés, portant atteinte aux droits de tiers, ou contraires aux règles de modération de Qubiq.",
      },
      {
        title: "4. Propriété intellectuelle",
        body: "Les éléments de la plateforme Qubiq, son design, ses marques, ses visuels, ses interfaces et ses développements restent protégés. Sauf autorisation expresse, ils ne peuvent pas être copiés, reproduits, extraits ni réutilisés à des fins commerciales.",
      },
      {
        title: "5. Suspension ou suppression de compte",
        body: "Qubiq peut restreindre, suspendre ou supprimer l’accès à tout ou partie du service en cas de non-respect des présentes conditions, de tentative de fraude, de comportement nuisible à la communauté ou de risque de sécurité.",
      },
      {
        title: "6. Contact",
        body: "Pour toute question sur ces conditions, tu peux écrire à {{contactEmail}}.",
      },
    ],
  },
  privacy: {
    title: "Politique de confidentialité",
    subtitle: "Comment Qubiq traite les données personnelles et comment exercer tes droits.",
    sections: [
      {
        title: "Responsable du traitement",
        body: "{{companyName}}, accessible via {{websiteUrl}}, agit en qualité de responsable du traitement pour les données traitées dans le cadre de la plateforme {{brandName}}.",
      },
      {
        title: "Données traitées",
        body: "Selon ton usage du service, nous pouvons traiter : identité de compte, email, pseudo, image de profil, historique d’usage, interactions communautaires, préférences de consentement, informations techniques de navigation et données liées au wallet ou aux gains lorsque ces fonctions sont utilisées.",
      },
      {
        title: "Finalités et bases légales",
        body: "- Fournir le service, la lecture vidéo, les jeux, le profil et les notifications : exécution du service.\n- Sécuriser la plateforme, lutter contre la fraude et modérer les contenus : intérêt légitime et obligations légales.\n- Gérer les demandes de support et les droits RGPD : obligation légale et intérêt légitime.\n- Mesurer l’audience avec Google Analytics : consentement.",
      },
      {
        title: "Destinataires",
        body: "Les données sont accessibles, selon leur besoin, aux équipes habilitées de Qubiq et à ses prestataires techniques. Qubiq utilise notamment Clerk pour l’authentification et Google Analytics pour la mesure d’audience lorsque tu l’acceptes.",
      },
      {
        title: "Durées de conservation",
        body: "Les durées varient selon la finalité :\n- compte utilisateur : pendant la durée d’existence du compte puis selon les obligations légales applicables ;\n- journaux techniques et sécurité : durée limitée nécessaire à la sécurité et au diagnostic ;\n- préférences cookies : 6 mois ;\n- données d’audience : selon la configuration Google Analytics et la politique de conservation retenue par Qubiq.",
      },
      {
        title: "Transferts hors UE",
        body: "Certains prestataires peuvent traiter des données hors de l’Union européenne. Dans ce cas, Qubiq met en place les garanties appropriées exigées par le RGPD, notamment des clauses contractuelles adéquates lorsqu’elles sont nécessaires.",
      },
      {
        title: "Tes droits",
        body: "Tu disposes, selon les cas, des droits d’accès, de rectification, d’effacement, d’opposition, de limitation, de portabilité et du droit de retirer ton consentement à tout moment pour les traitements fondés sur celui-ci. Tu peux également introduire une réclamation auprès de la CNIL.",
      },
      {
        title: "Contact données personnelles",
        body: "Pour toute demande relative à tes données personnelles : {{privacyEmail}}.",
      },
    ],
  },
  legalNotice: {
    title: "Mentions légales",
    subtitle: "Informations sur l’éditeur du service et l’hébergement du site.",
    items: {
      editorLabel: "Éditeur du site",
      legalFormLabel: "Forme juridique",
      legalFormValue: "{{legalForm}} — capital social : {{capital}}",
      registrationLabel: "Immatriculation",
      registrationValue: "RCS {{registrationCity}} {{registrationNumber}}",
      registrationDateLabel: "Date d'immatriculation",
      euidLabel: "EUID",
      vatLabel: "Numéro de TVA intracommunautaire",
      addressLabel: "Adresse",
      activitiesLabel: "Activités principales",
      publicationDirectorLabel: "Directeur de la publication",
      contactLabel: "Contact",
      hostingLabel: "Hébergement",
      hostingValue: "{{hostingCompany}}\n{{hostingAddress}}",
      intellectualPropertyLabel: "Propriété intellectuelle",
      intellectualPropertyValue:
        "Les contenus, interfaces, marques, visuels et développements du service Qubiq sont protégés. Toute reproduction ou exploitation non autorisée est interdite.",
    },
  },
  cookies: {
    title: "Politique cookies",
    subtitle: "Informations sur les traceurs utilisés par Qubiq et sur la gestion de tes choix.",
    sections: [
      {
        title: "Principe",
        body: "Qubiq utilise des cookies et autres traceurs nécessaires au fonctionnement du service. Les traceurs de mesure d’audience sont désactivés par défaut et ne sont activés qu’après ton accord explicite.",
      },
      {
        title: "Catégories utilisées",
        body: "- Cookies nécessaires : sécurité, connexion, stabilité de session, fonctionnement essentiel.\n- Mesure d’audience : Google Analytics 4, avec consentement.\n- Marketing : non activé pour le moment sur Qubiq.",
      },
      {
        title: "Durées et tiers",
        body: "- Préférence de consentement Qubiq : stockée localement sous la clé {{consentStorageKey}} pendant 6 mois.\n- {{analyticsProvider}} : cookies de mesure d’audience, durée par défaut annoncée par Google : jusqu’à 2 ans, sous réserve des limitations navigateur et de la configuration retenue par Qubiq.\n- Prestataire tiers concerné par la mesure d’audience : Google.",
      },
      {
        title: "Google Analytics",
        body: "{{analyticsProvider}} n’est pas chargé avant ton consentement. Quand tu l’acceptes, Qubiq utilise la mesure d’audience pour mieux comprendre l’usage du service, améliorer les performances et identifier les grandes tendances de navigation.",
      },
      {
        title: "Retirer ou modifier son consentement",
        body: "Tu peux modifier tes choix à tout moment depuis le bouton “Gérer mes cookies” disponible sur cette page, dans les liens d’information du site et dans le menu profil.",
      },
      {
        title: "Rappel réglementaire",
        body: "Sur Qubiq, refuser les cookies de mesure d’audience est aussi simple que les accepter. Le service principal reste accessible sans activation de Google Analytics.",
      },
    ],
  },
  moderation: {
    title: "Règles de modération Qubiq",
    subtitle: "Les règles de la Qubiq Republic pour protéger la communauté, les créateurs et les joueurs.",
    sections: [
      {
        title: "1. Respect de la communauté",
        body: "Les insultes, attaques ciblées, humiliations, menaces, campagnes de harcèlement ou comportements destinés à nuire à un autre utilisateur, créateur ou modérateur ne sont pas autorisés.",
      },
      {
        title: "2. Contenus illégaux ou dangereux",
        body: "Sont interdits : apologie de crimes, terrorisme, contenus pédocriminels, doxxing, diffusion non autorisée de données personnelles, escroqueries, fraude, piratage, incitation à la haine, ou toute publication contraire à la loi.",
      },
      {
        title: "3. Tromperie, spam et manipulation",
        body: "Il est interdit de spammer, de manipuler artificiellement l’audience, de publier des faux concours, de tromper les utilisateurs sur les gains, les jeux, les qubs ou les conditions de participation.",
      },
      {
        title: "4. Protection des mineurs",
        body: "Les contenus sexualisés, choquants, humiliants ou dangereux pour les mineurs sont interdits. Les utilisateurs doivent éviter toute mise en scène inappropriée ou exploitation de publics vulnérables.",
      },
      {
        title: "5. Jeux et fair-play",
        body: "Toute tentative de triche, d’automatisation abusive, de contournement des règles de run, de duplication de gains, d’exploitation de bug ou d’altération volontaire de l’expérience de jeu pourra entraîner une suspension ou une suppression de compte.",
      },
      {
        title: "6. Droits des tiers",
        body: "Tu dois disposer des droits nécessaires pour publier un contenu sur Qubiq. Les atteintes aux droits d’auteur, à l’image, à la vie privée ou aux marques d’autrui peuvent entraîner une modération immédiate.",
      },
      {
        title: "7. Mesures possibles",
        body: "Qubiq peut supprimer un contenu, limiter certaines fonctions, bloquer un partage, suspendre un compte, retirer des avantages liés à la plateforme ou signaler les faits aux autorités lorsqu’une situation le justifie.",
      },
      {
        title: "8. Esprit Qubiq",
        body: "Qubiq est une plateforme interactive : on peut débattre, jouer, performer et partager. Mais l’expérience doit rester saine, loyale, lisible et respectueuse. Si un contenu casse cette dynamique, il peut être modéré.",
      },
    ],
  },
};

export default legal;
